import React, { useState } from 'react';
import { X, Building2, Search, ArrowRight } from 'lucide-react';

const GstModal = ({ isOpen, onClose, onSubmit }) => {
  const [gstNumber, setGstNumber] = useState('');
  const [error, setError] = useState('');

  // Simple regex validation for Indian GST Number format
//   const validateGst = (gst) => {
//     const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
//     return gstRegex.test(gst);
//   };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Optional basic validation before hitting the API
    if (!gstNumber.trim()) {
      setError('GST number is required');
      return;
    }
    
    // if (!validateGst(gstNumber)) {
    //   setError('Please enter a valid 15-character GST number');
    //   return;
    // }

    setError('');
    
    // Triggering the parent's API logic with the requested payload
    onSubmit({
      gst_number: gstNumber
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200">
      {/* Modal Container */}
      <div 
        className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all scale-100"
        role="dialog"
        aria-modal="true"
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <div className="p-2 bg-blue-50 rounded-lg">
              <Building2 className="w-5 h-5 text-blue-600" />
            </div>
            <h2 className="text-lg font-semibold text-gray-800">
              Verify Business Details
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 transition-colors rounded-full hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-6">
            <label 
              htmlFor="gst_number" 
              className="block mb-2 text-sm font-medium text-gray-700"
            >
              GST Number <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <Search className="w-5 h-5 text-gray-400" />
              </div>
              <input
                type="text"
                id="gst_number"
                value={gstNumber}
                onChange={(e) => {
                  setGstNumber(e.target.value.toUpperCase());
                  setError('');
                }}
                className={`block w-full py-3 pl-10 pr-3 text-gray-900 placeholder-gray-400 uppercase transition-colors bg-gray-50 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white sm:text-sm ${
                  error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : 'border-gray-200 focus:border-blue-500'
                }`}
                placeholder="07AABCF8078M1Z3"
                maxLength={15}
                autoComplete="off"
              />
            </div>
            {error ? (
              <p className="mt-2 text-sm text-red-500">{error}</p>
            ) : (
              <p className="mt-2 text-xs text-gray-500">
                Enter a 15-character valid alphanumeric GST identification number.
              </p>
            )}
          </div>

          {/* Footer / Action */}
          <button
            type="submit"
            className="flex items-center justify-center w-full gap-2 px-4 py-3 text-sm font-medium text-white transition-all duration-200 shadow-md rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
          >
            Fetch Details
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default GstModal;